import(/* webpackMode: "eager" */ "/repo/apps/web/app/error.tsx");
